const AUTH_FLAG_KEY = 'authenticated'

export const setAuthFlag = (): void => {
  localStorage.setItem(AUTH_FLAG_KEY, '1')
}

export const readAuthFlag = (): boolean => localStorage.getItem(AUTH_FLAG_KEY) === '1'

export const clearAuthFlag = (): void => localStorage.removeItem(AUTH_FLAG_KEY)

export const persistUser = (userId: string): void => {
  localStorage.setItem('user', userId)
}

export const readUser = (): string => localStorage.getItem('user') || ''
export const deleteUser = (): void => localStorage.removeItem('user')
